<template>
    <g>
        <path
            d="M3.3335 3.8335V8.00016H3.81809M16.6152 9.66683C16.2052 6.37824 13.3998 3.8335 10.0002 3.8335C7.20235 3.8335 4.80707 5.55697 3.81809 8.00016M3.81809 8.00016H7.50016M16.6668 17.1668V13.0002H16.1822M16.1822 13.0002C15.1933 15.4434 12.798 17.1668 10.0002 17.1668C6.60048 17.1668 3.79516 14.6221 3.38507 11.3335M16.1822 13.0002H12.5002"
            :stroke="iconFill"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
</template>
<script>
export default {
    name: "Refresh2021",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
